let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("18CZ5")).then(() => parcelRequire('bTpte'));